import type { Response } from '@/api/axiosInstance';
import type { TFunction } from 'i18next';

export const getLaTeXCompileRequestFeedback = (
    result: Response<string> | undefined,
    t: TFunction<'common'>,
) => {
    if (result?.ok) {
        return {
            level: 'info' as const,
            content: t('editor_tabs.latex_compiling'),
        };
    }

    return {
        level: 'error' as const,
        content: t('editor_tabs.latex_failed'),
    };
};